<template>
    <Message :avatar="contact.avatar" :isRight="false" :date="message.created_at">
        <div class="pa3 bodyCopy">{{message.text}}</div>        
    </Message>    
</template>

<script>
import Message from '@/components/inbox/messagesCard/shared/Message.vue';

export default {
    components: {
        Message
    },
    props: {
        message: {
            type: Object
        },
        contact: {
            type: Object
        }
    }
};
</script>
